

































































































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop, PropSync } from 'vue-property-decorator'
import Radio from '@/modules/shared/components/shared/kit/Radio.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import QForm from 'quasar/src/components/form/QForm.js';
import { BillingInfoResourceModel, BillingInfoType } from '@/modules/billing-info/models/billing-info-resource'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import { PanelUpdateBillingInfoUseCase } from '@/modules/billing-info/use-cases/panel-update-billing-info.use-case'

@Component({
  components: { Modal, BaseButton, BaseInput, Radio }
})
export default class BillingInfoEditForm extends Vue {

  constructor(
    private readonly updateUseCase: PanelUpdateBillingInfoUseCase
  ) {
    super()
  }

  @Prop({ required: true }) billingInfo !: BillingInfoResourceModel
  @PropSync('displayEditForm') showModal!: boolean

  private PERSONTYPES = BillingInfoType

  $refs!: {
    legal: QForm,
    natural: QForm
  }

  async send() {
    let ok = false

    if (this.billingInfo.type === BillingInfoType.LEGAL) {
      ok = await this.$refs.legal.validate()
    } else {
      ok = await this.$refs.natural.validate()
    }

    if (!ok) return

    this.updateUseCase.execute(this.billingInfo).onSuccess(() => {
      this.showModal = false
    })

  }

  get legalIsDisable() {
    return this.billingInfo.type === 'natural'
  }

  get realIsDisable() {
    return this.billingInfo.type === 'legal'
  }
}
